import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { config } from '../function/config'
import { toast } from 'react-toastify'
import { FaTimes, FaBars, FaHandHoldingHeart } from 'react-icons/fa'

export default function Donate() {
    const [menuOpen, setMenuOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    const [branches, setBranches] = useState([])

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        branch:''
    })


    const [errors, setErrors] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        branch:''
    })


    const handleChange = (e) => {
        const { name, value } = e.target

        let newValue = value

        if (name === 'phone'){
            newValue = value.replace(/\D/g, '').slice(0, 10)
        }

        if(name === 'email'){
            newValue = value.replace(/\s/g,'')
        }

        setFormData((prev) => ({
            ...prev,
            [name]:newValue
        }))

        let error = ''

        if(name === 'phone'){
            if(newValue){
                if(!/^\d+$/.test(newValue)){
                error = 'Phone number must contain only digits'
                }else if(!/^[6-9]/.test(newValue)){
                error = 'Phone number must start with 6,7,8 or 9'
                }else if(newValue.length < 10){
                error = 'Phone number must contain exactly 10 digits'
                }
            }
        }

        // Email
        if(name === 'email'){
            if(newValue){
                if(!newValue.includes('@')){
                    error = 'Missing @ symbol'
                }else{
                    const [username, domain] = newValue.split('@')

                    if (!username) {
                        error = 'Username is missing before "@".'
                    } else if (!domain) {
                        error = 'Domain name is missing'
                    } else if (!domain.includes('.')) {
                        error = 'Missing "dot(.)" after domain name'
                    } else {
                        const parts = domain.split('.')
                        const extension = parts.slice(1).join('.')

                        if (!extension) {
                            error = 'Domain extension is missing'
                        } else {
                            const allowedDomains = [
                                'gmail.com',
                                'yahoo.com',
                                'hotmail.com',
                                'outlook.com'
                            ]

                            if (!allowedDomains.includes(domain.toLowerCase())) {
                                error = 'Only gmail.com, yahoo.com, hotmail.com and outlook.com are allowed'
                            }
                        }
                    }
                }
            }
        }

        setErrors((prev) => ({
            ...prev,
            [name]:error
        }))
    }

    const validateForm = (data) => {
        const newErrors = {}

        if(!data.name.trim()){
            newErrors.name = 'Donar Name is required'
        }

        if(!data.subject.trim()){
            newErrors.subject = 'Subject is required'
        }

        if(!data.message.trim()){
            newErrors.message = 'Message is required'
        }

        // Email
        if (data.email) {
            const email = data.email.trim()

            if (!email.includes('@')) {
                newErrors.email = 'Missing @ Symbol'
            } else {
                const [username, domain] = email.split('@')

                if (!username) {
                    newErrors.email = 'Username is missing before "@".'
                } else if (!domain) {
                    newErrors.email = 'Domain name is missing'
                } else if (!domain.includes('.')) {
                    newErrors.email = 'Missing "dot(.)" after domain name'
                } else {
                    const parts = domain.split('.')
                    const extension = parts.slice(1).join('.')

                    if (!extension) {
                        newErrors.email = 'Domain extension is missing'
                    } else {
                        const allowedDomains = [
                        'gmail.com',
                        'yahoo.com',
                        'hotmail.com',
                        'outlook.com'
                        ]

                        if (!allowedDomains.includes(domain.toLowerCase())) {
                            newErrors.email = 'Only gmail.com, yahoo.com, hotmail.com and outlook.com are allowed'
                        }
                    }
                }
            }
        }

        // Phone
        if (data.phone) {
            if (!/^\d+$/.test(data.phone)) {
                newErrors.phone = 'Phone number contain only digits'
            } else if (!/^[6-9]\d{9}$/.test(data.phone)) {
                newErrors.phone = 'Phone number must start with 6, 7, 8 or 9 and contain exactly 10 digits'
            }
        }

        if(!data.branch.trim()){
            newErrors.branch = 'Role is required'
        }

        return newErrors
    }

    const fetchBranches = async() => {
        try{
            const res = await axios.get(`${config.baseurl}get_all_branches/`,{
                headers:{
                    'Content-Type':'application/json'
                }
            })
            console.log('All Admins Res:', res.data)

            if(res.status === 200){
                setBranches(res.data.data)
            }else{
                toast.error('Failed o fetch branches')
            }
        }catch(error){
            console.error('Error:', error.response?.data || error)

            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to create branch'

            toast.error(message)
        }
    }

    useEffect(() => {
        fetchBranches()
    },[])
    console.log('All branhss:', branches)

    const handleSubmit = async (e) => {
        e.preventDefault()

        const validationErrors = validateForm(formData)

        setErrors(validationErrors)
        
        if(Object.keys(validationErrors).length > 0){
            return
        }

        setLoading(true)

        try {
            const payload = {
                name:formData.name,
                email:formData.email,
                phone:formData.phone,
                subject:formData.subject,
                message:formData.message,
                branch:formData.branch
            }

            const res = await axios.post(`${config.baseurl}create_donation_enquiry/`, payload, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            if (res.status === 201 || res.status === 200) {
                toast.success('Donation enquiry submitted successfully')

                setFormData({
                    name: '',
                    address: '',
                    branch: '',
                    subject: '',
                    message: ''
                })
            }
        } catch (error) {
            console.error('Error:', error.response?.data || error)

            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to create branch'

            toast.error(message)
        } finally {
            setLoading(false)
        }
    }

    const inputClass ='w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 placeholder:text-slate-400'

    return (
        <div className="min-h-screen bg-slate-50">

            {/* ================= HEADER ================= */}
            <header className="fixed top-0 left-0 right-0 bg-[#191c24] z-50 shadow-md">
                <div className="max-w-full mx-auto px-4 py-2 flex justify-between items-center">

                    {/* Logo + Name */}
                    <div className="flex items-center gap-3 text-white">

                        <img
                            src={require('../images/Logo.jpg')}
                            alt="Aurevia Charitable Trust Logo"
                            className="w-12 h-12 object-contain rounded"
                        />

                        <h1 className="text-xl font-bold 3xl:text-lg 2xl:text-base">
                            Aurevia Charitable Trust
                        </h1>

                    </div>

                    {/* Desktop Navigation */}
                    <nav className="flex 4xl:hidden gap-5 text-white items-center">

                        <Link
                            href="#home"
                            className="no-underline text-white"
                        >
                            Home
                        </Link>

                        <Link
                            href="#about-us"
                            className="no-underline text-white"
                        >
                            About Us
                        </Link>

                        <Link
                            href="#contact-us"
                            className="no-underline text-white"
                        >
                            Contact Us
                        </Link>

                        <Link
                            href="#our-programs"
                            className="no-underline text-white"
                        >
                            Our Programs
                        </Link>

                        <Link
                            to="/donation"
                            className="no-underline text-white"
                        >
                            Donate
                        </Link>

                        <Link
                            to="/login"
                            className="no-underline text-white"
                        >
                            Login
                        </Link>

                    </nav>

                    {/* Mobile Menu Button */}
                    <button
                        type="button"
                        className="hidden 4xl:flex text-2xl text-white"
                        onClick={() => setMenuOpen((prev) => !prev)}
                    >
                        {menuOpen ? <FaTimes /> : <FaBars />}
                    </button>

                </div>

                {/* Mobile Navigation */}
                {menuOpen && (
                    <div className="hidden 4xl:block absolute top-full right-0 w-64 bg-[#191c24] border-l border-slate-600 shadow-lg">

                        <nav className="flex flex-col py-3">

                            <Link
                                href="#home"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Home
                            </Link>

                            <Link
                                href="#about-us"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                About Us
                            </Link>

                            <Link
                                href="#contact-us"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Contact Us
                            </Link>

                            <Link
                                href="#our-programs"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Our Programs
                            </Link>

                            <Link
                                to="/donation"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Donate
                            </Link>

                            <Link
                                to="/login"
                                onClick={() => setMenuOpen(false)}
                                className="px-5 py-3 text-white no-underline"
                            >
                                Login
                            </Link>
                        </nav>
                    </div>
                )}
            </header>

            {/* ================= MAIN CONTENT ================= */}
            <main className="pt-24 pb-10 px-4 sm:px-6">
                <section className="max-w-5xl mx-auto">

                    {/* Page Heading */}
                    <div className="text-center mb-8">
                        <h2 className="text-3xl sm:text-4xl font-bold text-slate-800">
                            Donation Enquiry
                        </h2>

                        <p className="mt-2 text-slate-500 max-w-xl mx-auto">
                            Thank you for your interest in supporting
                            Aurevia Charitable Trust. Please provide your
                            details and our team will get in touch with you.
                        </p>
                    </div>

                    {/* Form Card */}
                    <div className="bg-white border border-slate-200 rounded-xl shadow-md overflow-hidden">
                        <div className="p-5 sm:p-8">
                            <form
                                onSubmit={handleSubmit}
                                className="space-y-6"
                            >

                                {/* Name */}
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                                    <div>
                                        <label
                                            htmlFor="name"
                                            className="block mb-2 text-sm font-semibold text-slate-700"
                                        >
                                            Full Name
                                            <span className="text-red-500 ml-1">*</span>
                                        </label>

                                        <input
                                            id="name"
                                            type="text"
                                            name="name"
                                            placeholder="Enter full name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            className={`${inputClass} ${errors.name
                                                ? 'border-red-500 focus:border-red-600'
                                                : ''
                                            }`}
                                        />

                                        {errors.name && (
                                            <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.name}</p>
                                        )}
                                    </div>

                                    {/* Email */}
                                    <div>
                                        <label
                                            htmlFor="email"
                                            className="block mb-2 text-sm font-semibold text-slate-700"
                                        >
                                            Email
                                            <span className="text-red-500 ml-1">*</span>
                                        </label>

                                        <input
                                            id="email"
                                            type="email"
                                            name="email"
                                            placeholder="Enter last name"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className={`${inputClass} ${errors.email
                                                ? 'border-red-500 focus:border-red-600'
                                                : ''
                                            }`}
                                        />

                                        {errors.email && (
                                            <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.email}</p>
                                        )}
                                    </div>
                                </div>

                                {/* Phone */}
                                <div>
                                    <label
                                        htmlFor="phone"
                                        className="block mb-2 text-sm font-semibold text-slate-700"
                                    >
                                        Phone
                                        <span className="text-red-500 ml-1">*</span>
                                    </label>

                                    <input
                                        id="phone"
                                        name="phone"
                                        type='phone'
                                        placeholder="Enter your complete phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className={`${inputClass} ${errors.phone
                                            ? 'border-red-500 focus:border-red-600'
                                            : ''
                                        }`}
                                    />

                                    {errors.phone && (
                                        <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.phone}</p>
                                    )}
                                </div>

                                <div>
                                    <label
                                        htmlFor="branch"
                                        className="block mb-2 text-sm font-semibold text-slate-700"
                                    >
                                        Branch
                                        <span className="text-red-500 ml-1">*</span>
                                    </label>

                                    <select
                                        id="branch"
                                        name="branch"
                                        value={formData.branch}
                                        onChange={handleChange}
                                        className={`${inputClass} ${errors.branch
                                            ? 'border-red-500 focus:border-red-600'
                                            : ''
                                        }`}
                                    >
                                        <option value="">Select Branches</option>
                                        {branches.map((item) => (
                                            <option 
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {item.branch_name}
                                            </option>
                                        ))}
                                    </select>

                                    {errors.department && (
                                        <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.department}</p>
                                    )}
                                </div>

                                <div>
                                    <label
                                        htmlFor="subject"
                                        className="block mb-2 text-sm font-semibold text-slate-700"
                                    >
                                        Subject
                                        <span className="text-red-500 ml-1">*</span>
                                    </label>

                                    <input
                                        id="subject"
                                        type="text"
                                        name="subject"
                                        placeholder="Enter subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        className={`${inputClass} ${errors.subject
                                            ? 'border-red-500 focus:border-red-600'
                                            : ''
                                        }`}
                                    />

                                    {errors.subject && (
                                        <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.subject}</p>
                                    )}

                                </div>

                                {/* Message */}
                                <div>
                                    <label
                                        htmlFor="message"
                                        className="block mb-2 text-sm font-semibold text-slate-700"
                                    >
                                        Message
                                        <span className="text-red-500 ml-1">*</span>
                                    </label>

                                    <textarea
                                        id="message"
                                        name="message"
                                        rows={5}
                                        placeholder="Tell us how you would like to support our initiatives..."
                                        value={formData.message}
                                        onChange={handleChange}
                                        className={`${inputClass} ${errors.message
                                            ? 'border-red-500 focus:border-red-600'
                                            : ''
                                        }`}
                                    />

                                    {errors.message && (
                                        <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.message}</p>
                                    )}
                                </div>

                                {/* Submit */}
                                <div className="flex justify-end pt-2">

                                    <button
                                        type="submit"
                                        disabled={loading}
                                        className="px-7 py-3 rounded-lg bg-[#191c24] text-white font-semibold transition hover:bg-slate-700 disabled:opacity-60 disabled:cursor-not-allowed"
                                    >
                                        {loading
                                            ? 'Submitting...'
                                            : 'Submit Enquiry'
                                        }
                                    </button>

                                </div>

                            </form>

                        </div>

                    </div>

                </section>

            </main>

        </div>
    )
}

